if (!customElements.get('video-carousel')) {
  class VideoCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-carousel]');

      if (!this.carousel || typeof Flickity === 'undefined') return;

      this.controls = this.querySelectorAll('[data-prev], [data-next]');
      this.controls.forEach((control) =>
        control.addEventListener('click', (event) => {
          if (!this.flickity) return;

          const isNext = event.currentTarget.hasAttribute('data-next');

          this.flickity[isNext ? 'next' : 'previous']();
        }),
      );

      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.sync(), 150);
      };

      window.addEventListener('resize', this.onResize);
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.resizeTimer);
      this.destroyCarousel();
    }

    // With few slides the row doesn't overflow; a centered static row looks
    // right and there is nothing to scroll, so no carousel. Flickity only
    // mounts when the slides genuinely overflow the viewport.
    sync() {
      const overflows = this.slidesWidth() > this.carousel.clientWidth + 1;

      if (overflows && !this.flickity) {
        this.initCarousel();
      } else if (!overflows && this.flickity) {
        this.destroyCarousel();
      }

      this.controls.forEach((control) => (control.hidden = !overflows));
    }

    slidesWidth() {
      return [...this.carousel.querySelectorAll('.video-carousel__slide')].reduce(
        (total, slide) => total + slide.offsetWidth,
        0,
      );
    }

    initCarousel() {
      this.flickity = new Flickity(this.carousel, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: this.dataset.cellAlign || 'center',
        wrapAround: this.dataset.wrap !== 'false',
      });

      this.flickity.on('change', () => {
        if (window.pauseAllMedia) window.pauseAllMedia();
      });
    }

    destroyCarousel() {
      if (!this.flickity) return;

      this.flickity.destroy();
      this.flickity = null;
    }
  }

  customElements.define('video-carousel', VideoCarousel);
}
